<section id="content">
  <router-outlet></router-outlet>
</section>
